module.exports = __webpack_public_path__ + "static/media/safety.68abede6.png";